var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49995 6.74C6.10995 6.74 5.84995 7 5.84995 7.39C5.84995 7.65 6.04495 7.845 6.23995 7.91L6.04495 8.82H6.88995L6.69495 7.91C6.95495 7.845 7.08495 7.65 7.08495 7.39C7.14995 7 6.88995 6.74 6.49995 6.74ZM6.56495 3.945C6.10995 3.945 5.65495 4.27 5.65495 4.725V5.7H7.40995V4.725C7.34495 4.27 7.01995 3.945 6.56495 3.945ZM6.49995 1.8L1.94995 3.75V5.7C2.01495 8.56 3.83495 11.095 6.49995 12.135C9.16495 11.095 10.985 8.56 11.05 5.7V3.75L6.49995 1.8ZM9.09995 8.95C9.09995 9.34 8.83995 9.6 8.44995 9.6H4.54995C4.15995 9.6 3.89995 9.34 3.89995 8.95V6.35C3.89995 5.96 4.15995 5.7 4.54995 5.7H4.74495V4.725C4.80995 3.815 5.58995 3.1 6.49995 3.1C7.40995 3.1 8.18995 3.815 8.25495 4.725V5.7H8.44995C8.83995 5.7 9.09995 5.96 9.09995 6.35V8.95Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.011beee25286d7d93959ba1fa53daab6.svg";
export { ForwardRef as ReactComponent };